import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    imageAlt: string;
    title: string;
    subtitle: {
        /** Default subtitle when semantic search is disabled */
        default: string;
        /** Subtitle when semantic search is enabled */
        semantic: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Alt text for search illustration image */
            imageAlt: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "IntroBlock.imageAlt?c=3sfle8m8e8sbw", defaultMessage: "Search illustration" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Main title for the search intro block */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "IntroBlock.title?c=37uq3bwq0d6ws", defaultMessage: "Meet the redesigned search\u2014find what you need fast." }));
                },
                enumerable: true,
                configurable: true
            },
            subtitle: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Default subtitle when semantic search is disabled */
                        default: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "IntroBlock.subtitle.default?c=2lyypaa1vp1ww", defaultMessage: "Precisely track down a file, status, assignee, and more." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Subtitle when semantic search is enabled */
                        semantic: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "IntroBlock.subtitle.semantic?c=25op1v1sybiid", defaultMessage: "Use natural language to locate files by status, transcripts, comments and more." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
